<template>
  <font-awesome-icon
    icon="users"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUsers } from '@fortawesome/free-solid-svg-icons'

library.add(faUsers)

export default {
  name: 'CoozzyUsersIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-grey-dark;
  }
</style>
